<template>
  <div id="app">
    <LayContainer v-if="islogin">
      <router-view :key="$route.fullPath"></router-view>
    </LayContainer>
    <router-view v-else :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
import LayContainer from '@/components/layout/lay-container'
export default {
  components: { LayContainer },
  data() {
    return {
      islogin: false
    }
  },
  watch: {
    '$route.path': {
      handler: function (val) {
        // 处理路由参数变化后的操作
        if (val == '/login') {
          this.islogin = false
        } else {
          this.islogin = true
        }
      }
    }
  },
  created() {
    this.findRoleVersion()
    if (
      localStorage.getItem('runTimeTest') == 'true' ||
      localStorage.getItem('runTimeTest') == true
    ) {
      this.$store.dispatch('asyncUpdateRunTimeTest', true)
    } else {
      this.$store.dispatch('asyncUpdateRunTimeTest', false)
    }
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeyDown)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown)
  },
  methods: {
    // 每次刷新，重新读取用户权限
    findRoleVersion() {
      this.$api({
        method: 'post',
        url: '/admin/roleVersion',
        data: {
          roleVersion: this.$store.getters.getRoleVersion
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          if (res.data.roleVersion != null && res.data.account != null) {
            this.$store.dispatch('asyncUpdateRoleVersion', res.data.roleVersion)
            this.$store.dispatch('asyncUpdateLoginAccount', res.data.account)
          }
        }
      })
    },
    // 解决一些浏览器按Backspace键返回页面问题，如360浏览器等
    handleKeyDown(event) {
      let isStop =
        event.key === 'Backspace' &&
        document.activeElement.tagName !== 'INPUT' &&
        document.activeElement.tagName !== 'TEXTAREA'
      if (isStop) event.preventDefault()
    }
  }
}
</script>

<style lang="less"></style>
